module.exports = __webpack_public_path__ + "static/img/p4.23cd27e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/importMp3/p4.png
// module id = 8xSj
// module chunks = 0